import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { OasCheckResponse } from '#api/tmsApiService'
import { type ResultUpdater, runCheck } from '#app/store/middlewares/configurationRequests/checks/runCheck'
import type { TruckConfiguration } from '#store/slices/configurationSlice'
import type { CheckResult, CheckTaskId } from '#types/ConfigurationCheck'
import type { AppListenerApi } from '../../configurationRequestMiddleware'

export const oasExtendedCheckId = 'checkExtendedOas' as CheckTaskId
export const oasTcrVcrCheckId = 'checkTcrVcrOas' as CheckTaskId

export function isOasResult(result: CheckResult): result is CheckResult<OasCheckResponse> {
  return result.id === oasExtendedCheckId || result.id === oasTcrVcrCheckId
}

export function runOasCheck(
  api: AppListenerApi,
  configuration: TruckConfiguration,
  updater: ResultUpdater,
  checkType: 'extended' | 'tcr_vcr' = 'tcr_vcr',
) {
  if (!configuration.uuid) {
    return
  }
  const promise = api.dispatch(
    enhancedTmsApiService.endpoints.getConfigurationByUuidCheckOas.initiate(
      { uuid: configuration.uuid, checkType },
      {
        forceRefetch: true,
      },
    ),
  )

  return runCheck(
    promise,
    {
      id: checkType === 'extended' ? oasExtendedCheckId : oasTcrVcrCheckId,
    },
    updater,
  )
}
